import React from "react";
import { Label } from "./inputLabel.styles";

export const InputLabel = props => {
  const { name, toolTipText, title, accessibleLabel, id, onClick, children } = props;
  const labelContents = children || title;

  return (
    <>
      {labelContents && <Label onClick={onClick} htmlFor={name} id={!!id ? id : `${name}Label`} aria-label={accessibleLabel} data-tooltip={toolTipText}>{labelContents}</Label>}
    </>
  );
};